import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { filter, map, mergeMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CanonicalTagsService {
  constructor(
    private meta: Meta,
    private title: Title,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    @Inject(DOCUMENT) private document: Document,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  init() {
    // Initial update for SSR
    this.updateTags(this.router.url);

    // Update on route changes (client-side)
    if (isPlatformBrowser(this.platformId)) {
      this.router.events
        .pipe(
          filter(event => event instanceof NavigationEnd),
          map(() => this.activatedRoute),
          map(route => {
            while (route.firstChild) route = route.firstChild;
            return route;
          }),
          mergeMap(route => route.data)
        )
        .subscribe(() => {
          this.updateTags(this.router.url);
        });
    }
  }

  private updateTags(currentRoute: string) {
    const baseUrl = 'https://takeoffprojects.com';
    const fullUrl = `${baseUrl}${currentRoute}`;

    console.log('Updating canonical tags for URL:', fullUrl);

    // Update og:url meta tag
    this.meta.updateTag({ property: 'og:url', content: fullUrl });

    // Update canonical link
    this.updateCanonicalUrl(fullUrl);

    // Update alternate link
    this.updateAlternateLink(fullUrl);
  }

  private updateCanonicalUrl(url: string) {
    let link: HTMLLinkElement = this.document.querySelector(
      'link[rel="canonical"]'
    );
    if (!link) {
      link = this.document.createElement('link');
      link.setAttribute('rel', 'canonical');
      this.document.head.appendChild(link);
    }
    link.setAttribute('href', url);
  }

  private updateAlternateLink(url: string) {
    let link: HTMLLinkElement = this.document.querySelector(
      'link[rel="alternate"][hreflang="en"]'
    );
    if (!link) {
      link = this.document.createElement('link');
      link.setAttribute('rel', 'alternate');
      link.setAttribute('hreflang', 'en');
      this.document.head.appendChild(link);
    }
    link.setAttribute('href', url);
  }
}
